import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import { LightBoxWrapper } from '../common/LightBoxWrapper.js';
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';

import { SigninOverlayMessageContainer } from './containers/SigninOverlayMessageContainer.js';
import { SigninOverlayEmailContainer } from './containers/SigninOverlayEmailContainer.js';
import { SigninOverlayPasswordContainer } from './containers/SigninOverlayPasswordContainer.js';

import { signinStatuses } from './constants/signinOverlayConstants.js';
import { isEmailSent } from './utilities/signinUtilities.js';
import { decodeXml } from '../utils/encodeXML.ts';

export const SigninOverlay = createReactClass({

    propTypes: {
        setUserCredentials: PropTypes.func.isRequired,
        reinitialize: PropTypes.func.isRequired,
        toggleSigninOverlay: PropTypes.func.isRequired,
        showSigninOverlay: PropTypes.bool.isRequired,
        isStandAloneSignin: PropTypes.bool.isRequired,
        loading: PropTypes.bool,
        signinStatus: PropTypes.string,
    },

    componentWillUnmount: function () {
        $(window).trigger('signinOverlayWillUnmount');
    },

    getDefaultProps: function () {
        return {
            signinStatus: signinStatuses.NONE,
            loading: false,
        };
    },

    // used externally -- callback after iframe post
    signinOverlayCallback: function (data) {
        if (data) {
            if (data.userCredentials.signinStatus === signinStatuses.COMPLETE) {
                if (this.props.isStandAloneSignin && data.userCredentials.redirectURL) {
                    window.location.href = decodeXml(data.userCredentials.redirectURL);
                } else {
                    this.props.setUserCredentials(data);
                    $(window).trigger('signinTriggered');
                }
            } else {
                this.props.setUserCredentials(data);
            }
        }
    },

    // used externally to clear fields -- see header.js function: notYou
    reinitialize: function () {
        this.props.reinitialize();
    },

    // used externally as well as internally -- see header.js functions: toggleContactFormSignInOverlay, toggleCartSignInOverlay, toggleSignInOverlay
    toggleSignin: function (username, first, signinStatus) {
        this.props.toggleSigninOverlay(username, first, signinStatus);
    },

    showLoading: function () {
        if (this.props.loading) {
            $('#signin-overlay-submit-button').addClass('disabled');
            return (
                <LoadingEllipsis className={'page-loader'} />
            );
        }
        $('#signin-overlay-submit-button').removeClass('disabled');
        return null;
    },

    renderContents: function () {
        if (!this.props.showSigninOverlay) {
            return null;
        } else if (this.props.signinStatus === signinStatuses.COMPLETE) {
            return null;
        } else if (isEmailSent(this.props.signinStatus)) {
            return (
                <SigninOverlayMessageContainer />
            );
        } else if (this.props.signinStatus === signinStatuses.PASSWORD_REQUIRED || this.props.signinStatus === signinStatuses.PASSWORD_UNKNOWN) {
            return (
                <SigninOverlayPasswordContainer />
            );
        }
        return (
            <SigninOverlayEmailContainer />
        );
    },

    render() {
        const contents = this.renderContents();
        if (contents == null) {
            return null;
        } else if (this.props.isStandAloneSignin) {
            return (
                <div>
                    {this.showLoading()}
                    {this.renderContents()}
                </div>
            );
        } else {
            return (
                <LightBoxWrapper unMountHandler={this.toggleSignin}>
                    {this.showLoading()}
                    {this.renderContents()}
                </LightBoxWrapper>
            );
        }
    },
});
